import _ from 'lodash';

export default {
  data() {
    return {
      requestBeingProcessed: false,
      responseErrorMessage: null,
    };
  },

  methods: {
    handleSubmit() {
      this.$v.$touch();

      if (this.isRequestBeingProcessed()) {
        return false;
      }
      if (this.isInvalidRequestParams()) {
        return false;
      }

      this.onBeforeRequest();
      this.onMask();
      this.resetResponseError();

      this.$http
        .post(this.handleRequestUrl(), this.handleRequestParams())
        .then((response) => {
          this.handlePostResponce(response);
        })
        .catch((error) => {
          this.catchResponseError(error);
        })
        .finally(() => {
          this.onAfterRequest();
          this.onUnmask();
        });
    },

    /* You must redefine this */

    handlePostResponce(response) {
      if (this.isSuccessfulRequest(response)) {
        this.handleResponse(response);
      }
      if (this.isFailedRequest(response)) {
        this.handleResponseError(response);
      }
    },

    handleRequestUrl() {
      this.error('You must redefine handleRequestUrl');
    },

    handleRequestParams() {
      this.error('You must redefine handleRequestParams');
    },

    handleResponse(response) {
      this.error('You must redefine handleResponse');
    },

    /* Request events */

    onMask() {
      this.requestBeingProcessed = true;
    },

    onUnmask() {
      this.requestBeingProcessed = false;
    },

    /* Request events */

    onBeforeRequest() {},

    onAfterRequest() {},

    /* Request states */

    isSuccessfulRequest(response) {
      return _.has(response, 'data.status_code');
    },

    isFailedRequest(response) {
      return _.has(response, 'data.error_code');
    },

    isInvalidRequestParams() {
      if (this.$v.$invalid) {
        return true;
      }
      return false;
    },

    isValidRequestParams() {
      if (this.$v.$invalid) {
        return false;
      }
      return true;
    },

    isRequestBeingProcessed() {
      return this.requestBeingProcessed;
    },

    /* Response params */

    hasResponceKey(response, key) {
      return _.has(response, key);
    },

    getResponceKey(response, key) {
      return _.get(response, key);
    },

    getResponceStatusCode(response) {
      return _.get(response, 'data.status_code');
    },

    getResponceErrorCode(response) {
      return _.get(response, 'data.error_code');
    },

    /* Response errors */

    getResponseError() {
      return this.responseErrorMessage;
    },

    setResponseError(msg) {
      this.responseErrorMessage = msg;
    },

    resetResponseError() {
      this.responseErrorMessage = null;
    },

    // Перехват 4xx ошибок
    handleResponseError(response) {
      if (_.has(response, 'data.error_code')) {
        this.responseErrorMessage = _.get(response, 'data.error_code');
      }
    },

    // Перехват 5xx ошибок
    catchResponseError(error) {
      if (error.response) {
        if (_.has(error.response, 'data.error_code')) {
          this.responseErrorMessage = _.get(error.response, 'data.error_code');
        } else {
          this.log(error.response.data);
          this.log(error.response.status);
          this.log(error.response.headers);
        }
      } else if (error.request) {
        this.error(`Error ${error.message}`);
      } else {
        this.error(`Error ${error.message}`);
      }
    },
  },
};
